import { createFileRoute } from "@tanstack/react-router";
import { AdsPage } from "./annonser";

export const Route = createFileRoute("/es/anuncios")({
  head: () => ({
    meta: [
      { title: "Todos los anuncios – compra de segunda mano | Sellavo" },
      { name: "description", content: "Explora todos los anuncios de Sellavo y encuentra segunda mano cerca de ti." },
      { property: "og:title", content: "Todos los anuncios – compra de segunda mano | Sellavo" },
      { property: "og:description", content: "Explora todos los anuncios de Sellavo y encuentra segunda mano cerca de ti." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/anuncios" }],
  }),
  component: AdsPage,
});
